import Form from './Form';
import AlertRenderer from './ResponseRenderers/AlertRenderer';
import CookieManager from './Http/CookieManager';

window.formAlertRenderer = new AlertRenderer;

(function ($) {
    // jQuery plugin to be able to call formAlert() on any form to apply
    var form = new Form(formAlertRenderer, new CookieManager());
    $.fn.formAlert = function () {
        $(this).submit(function () {
            form.callback($(this).data('callback'));
            form.callbackError($(this).data('callback-error'));
            return form.submit(this);
        });
    };
}(jQuery));

$(document).ready(function () {
    // apply formAlert to all forms with the 'ajax' class
    $('body').on('submit', 'form.ajax', function () {
        var form = new Form(formAlertRenderer, new CookieManager());
        form.callback($(this).data('callback'));
        form.callbackError($(this).data('callback-error'));
        return form.submit(this);
    });
});



// WEBPACK FOOTER //
// ./app/app.js